export class NotificationTask {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
